import ContentBody from '@op/components/ContentBody';
import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import Gpt from '@op/components/GPT';
import { getKeyOpinionHighGameGPTReport } from '@op/services/keyOpinions';
import React from 'react';
import { Button, Layout } from 'tea-component';
import { connect, useIntl } from 'umi';
import { summaryGptTitle } from '../NIKKE/constants';
const { Content } = Layout;
function GPTPage({
  gameInfo,
  wholeGameInfo,
}: {
  gameInfo: any;
  wholeGameInfo: any;
}) {
  const {
    scrollBody,
    loading,
    filter,
    changeFilter,
    filterOptions,
    initState,
  } = useFilterDataHook({ gameInfo, pageName: 'Overview_Performance' });

  const { formatMessage } = useIntl();

  return (
    <Content className="dbo-page dbo-performance">
      <ContentBody
        contentHeard={
          <Content.Header className="dbo-header" title={'GPT'}></Content.Header>
        }
      >
        <FilterFixed
          scrollBody={scrollBody}
          filter={filterOptions}
          confirm={(value: any) => {
            changeFilter({ ...value, ...gameInfo });
          }}
        ></FilterFixed>

        <Gpt.PageCard
          filter={filter}
          hasStopBtn={true}
          requestFuncMap={{
            defaultRequest: getKeyOpinionHighGameGPTReport,
            dealwithParams: ({
              edition_unified_id,
              end_time,
              entity_type,
              id_type,
              start_time,
            }: any) => {
              return {
                edition_unified_id,
                end_time,
                entity_type,
                id_type,
                start_time,
              };
            },
          }}
          autoRequest={false}
        >
          {(toggleVisible, { loading, total }) => {
            return (
              <Gpt.Button
                disabled={total <= 0}
                loading={loading}
                onClick={() => toggleVisible()}
              ></Gpt.Button>
            );
          }}
        </Gpt.PageCard>

        <Gpt.MultiplePageCard
          filter={filter}
          hasStopBtn={true}
          requestFuncMap={{
            defaultRequest: getKeyOpinionHighGameGPTReport,
            dealwithParams: ({
              edition_unified_id,
              end_time,
              entity_type,
              id_type,
              start_time,
            }: any) => {
              return {
                edition_unified_id,
                end_time,
                entity_type,
                id_type,
                start_time,
              };
            },
          }}
          autoRequest={false}
          GPTList={summaryGptTitle}
        >
          {(toggleVisible, { loading, total }) => {
            return (
              <Button
                disabled={total <= 0}
                type="primary"
                loading={loading}
                onClick={() => toggleVisible()}
              >
                {formatMessage({ id: 'Get AI Summary' })}
              </Button>
            );
          }}
        </Gpt.MultiplePageCard>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon, opinionFilter } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    filter: opinionFilter,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(GPTPage);
